// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4Mmvs","checkIcon":"styles_checkIcon__gswzD","materialIcon":"styles_materialIcon__LQkOs","content":"styles_content__WuSkH"};